import { marquee } from '../../data/site';

/*--------------------
* Tech marquee
----------------------*/
export default function BrandSlider() {
  // Duplicated once so the -50% translate loops seamlessly.
  const loop = [...marquee, ...marquee];

  return (
    <div className="relative border-y border-tint/[.07] bg-tint/[.015] py-5">
      <div className="marquee-mask overflow-hidden">
        <div className="marquee-track gap-3">
          {loop.map((item, i) => (
            <span
              key={`${item}-${i}`}
              className="flex shrink-0 items-center gap-2.5 rounded-full border border-tint/[.07] bg-tint/[.03] px-4 py-2 font-mono text-[12px] tracking-[.02em] text-muted"
            >
              <i className="h-1 w-1 shrink-0 rounded-full bg-violet-brand/70" />
              {item}
            </span>
          ))}
        </div>
      </div>
    </div>
  );
}
